import { Email, UserInfo, WelcomeMessage } from '../../App.styles';
import { useSelector } from '../../modules/store';

const LoggedUserInfo = () => {
    const currentLoggedUser = useSelector((state) => state?.authorization?.currentLoggedUser);

    if (!currentLoggedUser?.username) {
        return null;
    }

    return (
        <UserInfo>
            <WelcomeMessage>
                Olá {currentLoggedUser.firstName} {currentLoggedUser.lastName}!
            </WelcomeMessage>
            <Email>{currentLoggedUser.email}</Email>
        </UserInfo>
    );
};

export default LoggedUserInfo;
